import { useNavigate } from 'react-router-dom';
import { useChatStore } from '../model/chatStore';

/** Clears the active chat and goes to Ask Research, which is the home page. */
export function useNewChat() {
  const navigate = useNavigate();
  const startNew = useChatStore((s) => s.startNew);
  return () => {
    startNew();
    void navigate('/');
  };
}
